module.exports = __webpack_public_path__ + "static/media/logs.01f16b47.png";